import { select } from 'redux-saga/effects';
import {
  isNavLocationInAreas,
  NavLocation,
  NavLocationAreas
} from '../layout/NavLocation';
import { AppState } from '../state/AppState';
import { isDatasourceOwnerPanelSubSpace } from '../state/SpaceInfo';
import { SessionUserSelectors } from './SessionInfoSelectors';

export namespace NavLocationSelectors {
  export function selectNavLocation(state: AppState): NavLocation {
    return state.navigationState.navLocation;
  }

  export function inServerArea(state: AppState): boolean {
    const location = selectNavLocation(state);
    return isNavLocationInAreas(location, NavLocationAreas.ServerAdmin);
  }

  export function inSiteArea(state: AppState): boolean {
    const location = selectNavLocation(state);
    const inArea = isNavLocationInAreas(location, NavLocationAreas.SiteContent, NavLocationAreas.SiteAdmin);
    return inArea || SessionUserSelectors.isSingleSiteServerAdmin(state);
  }

  export function inSiteContentArea(state: AppState) {
    const location = selectNavLocation(state);
    return isNavLocationInAreas(location, NavLocationAreas.SiteContent);
  }

  export function inVizViewerArea(state: AppState) {
    const location = selectNavLocation(state);
    return (location === NavLocationAreas.SiteContent.site_viz ||
            location === NavLocationAreas.SiteAdmin.site_viz ||
            location === NavLocationAreas.ServerAdmin.server_viz ||
            location === NavLocationAreas.SiteContent.datasource_owner_panel);
  }

  export function inSiteStatusViz(state: AppState) {
    const location = selectNavLocation(state);
    return location === NavLocationAreas.SiteAdmin.site_viz;
  }

  export function inServerStatusViz(state: AppState) {
    const location = selectNavLocation(state);
    return location === NavLocationAreas.ServerAdmin.server_viz;
  }

  export function inSearchNavLocation(state: AppState) {
    return selectNavLocation(state) === NavLocationAreas.SiteContent.search;
  }
}

export function selectPreviousUrl(state: AppState): string {
  return state.navigationState.previousUrl;
}
